import {
  DOWNLOAD_INVOICE_FILE_FAILURE,
  DOWNLOAD_INVOICE_FILE_REQUEST,
  DOWNLOAD_INVOICE_FILE_SUCCESS,
  FETCH_INVOICE_LIST_FAILURE,
  FETCH_INVOICE_LIST_REQUEST,
  FETCH_INVOICE_LIST_SUCCESS,
  GET_INVOICE_DETAILS_BY_ID_FAILURE,
  GET_INVOICE_DETAILS_BY_ID_REQUEST,
  GET_INVOICE_DETAILS_BY_ID_SUCCESS,
  ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE,
  ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST,
  ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS,
} from "./actionTypes";
import { InvoicesState } from "./types";

const initialState: InvoicesState = {
  invoicesList: [],
  loading: false,
  error: null,
  downloadLoading: false,
  downloadError: null,
  invoiceDetailsByID: null,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_INVOICE_LIST_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case FETCH_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        invoicesList: action.payload,
        error: null,
      };
    case FETCH_INVOICE_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case DOWNLOAD_INVOICE_FILE_REQUEST:
      return {
        ...state,
        downloadLoading: true,
        downloadError: null,
      };
    case DOWNLOAD_INVOICE_FILE_SUCCESS:
      return {
        ...state,
        downloadLoading: false,
        downloadError: null,
      };
    case DOWNLOAD_INVOICE_FILE_FAILURE:
      return {
        ...state,
        downloadLoading: false,
        downloadError: action.payload,
      };
    case GET_INVOICE_DETAILS_BY_ID_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
        invoiceDetailsByID: null,
      };
    case GET_INVOICE_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        invoiceDetailsByID: action.payload,
        error: null,
      };
    case GET_INVOICE_DETAILS_BY_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    case ADD_UPDATE_INVOICE_ML_ENTRY_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case ADD_UPDATE_INVOICE_ML_ENTRY_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload,
        error: null,
      };
    case ADD_UPDATE_INVOICE_ML_ENTRY_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
